import { render, staticRenderFns } from "./HowLongDoesItTakeForMeToGetPaid.vue?vue&type=template&id=d00e56f4&scoped=true"
import script from "./HowLongDoesItTakeForMeToGetPaid.vue?vue&type=script&lang=js"
export * from "./HowLongDoesItTakeForMeToGetPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00e56f4",
  null
  
)

export default component.exports